const tooltips = {
  esetek: 'A felületen különböző típusú bejelentéseket lehet rögzíteni, adott helyszínnel kapcsolatban.',
  allapot: 'Ezen a felületen rögzíthetőek azok az állapotok, amiket az eset típusok fel tudnak venni.',
  esettipus: 'Eset típusok rögzítésére és karbantartására szolgáló felület.',
  elerhetoseg: 'A helyszínek ügyfélszolgálatának az elérhetőségét lehet itt berögzíteni és karbantartani. A bejelentések a megadott email-címre fognak beérkezni. Az Idő mezőben rögzíthető az az idősáv, amelyben az ügyfélszolgálat elérhető.',
};

export default function getTooltip(name) {
  return tooltips[name];
}
